import React from 'react';
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import styled from "styled-components";

const SiteMapSkeleton = ({titleHeight, withoutContainer = false}) => {
    return (
        <SkeletonTheme color={props => props.theme.gray200} highlightColor="#444">
            <Container className={"mt-56 " + (withoutContainer ? 'pb-0' : 'container')}>
                <Skeleton width="200px" height={titleHeight ?? 40}/>

                <div className="row mt-8">
                    {
                        [...Array(9)].map((i, k) =>
                            <div className="col-12 col-lg-4 mt-24">
                                <Skeleton width="80%" height={16}/>
                            </div>
                        )
                    }
                </div>
            </Container>
        </SkeletonTheme>
    );
};

export default React.memo(SiteMapSkeleton);

// styles

const Container = styled.div`
    padding-bottom: 132px;
`;
